import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children, requirePremium = false, requireAdmin = false, requireVerified = true }) => {
    const { user, loading, isPremium, isAdmin } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <Loader2 className="w-8 h-8 animate-spin text-primary" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Check email verification (skip for admins)
    if (requireVerified && !user.is_verified && !user.is_admin) {
        return <Navigate to="/verify-email-required" replace />;
    }

    if (requirePremium && !isPremium) {
        return <Navigate to="/subscription" replace />;
    }

    if (requireAdmin && !isAdmin) {
        return <Navigate to="/chat" replace />;
    }

    return children;
};
